import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval";
import type { SpecificationMetadataState } from "types";
import type { Ref } from "vue";

const { data } = useIDBKeyval<SpecificationMetadataState[]>(
  "sterilizationSpecifications",
  [],
  {
    shallow: false,
  }
);
export function useSterilizationSpecificationsState(): Ref<
  SpecificationMetadataState[]
> {
  return data;
}
